<template>
  <div class="time-limit">
    <span class="title">Thời gian giới hạn làm trắc nghiệm: </span>
    <span class="time">{{ txtTime }}</span>
    <div class="btn-start" @click="setStartQuiz">
        Bắt đầu làm Quiz
    </div>
  </div>
</template>

<script>

export default {
  name: "LimitTime",
  props: ['timeLimit'],
  computed: {
    txtTime: function(){
      const minus = Math.floor(this.timeLimit/60)
      const seconds = this.timeLimit - minus*60
      if (minus > 0){
        return minus + " phút " + seconds + " giây"
      } else {
        return seconds + " giây"
      }
      
    }
  },
  methods: {
      setStartQuiz(){
          this.$store.dispatch('setStartQuiz');
      }
  }
};
</script>
